import Vue from 'vue'
import http from '../utils/http';

export default {
    state: {
        products: null,
        products_all: [],
        trademarks: [],
        DESIGN_TYPES: [
            {
                text_en:'classic',
                text_ro:'clasic',
                text_ru:'классический',
                value: 'classic'
            },
            {
                text_en:'business',
                text_ro:'afaceri',
                text_ru:'бизнес',
                value: 'business'
            },
            {
                text_en:'casual',
                text_ro:'casual',
                text_ru:'повседневный',
                value: 'casual'
            },
            {
                text_en:'innovative',
                text_ro:'inovator',
                text_ru:'инновационный',
                value: 'innovative'
            },
            {
                text_en:'art',
                text_ro:'artă',
                text_ru:'арт',
                value: 'art'
            }
        ],
        FEATURES: [
            {   text_en: 'positioning tracker',
                text_ro: 'dispozitiv de localizare',
                text_ru: 'трекер местоположения',
                value: 1
            },
            {
                text_en: 'power bank',
                text_ro: 'baterie externă',
                text_ru: 'портативный аккумулятор',
                value: 2
            },
            {
                text_en: 'missed items warning',
                text_ro: 'atentie articole uitate',
                text_ru: 'предупреждение об отсуствующих вещах',
                value: 3
            },
            {
                text_en: 'danger alarm',
                text_ro: 'alarmă de pericol',
                text_ru: 'сигнализатор об опасности',
                value: 4
            },
            {
                text_en: 'fridge camera',
                text_ro: 'cameră rigorifică',
                text_ru: 'холодильная камера',
                value: 5
            },
            {
                text_en: 'individual pictures',
                text_ro: 'fotografii personale',
                text_ru: 'индивидуальные изображения',
                value: 6
            },
            {
                text_en: 'against loss insurance',
                text_ro: 'asigurare împotriva pierderilor',
                text_ru: 'страхование от убытков',
                value: 7
            },
            {
                text_en: 'environment friendly utilization',
                text_ro: 'utilizare ecologică',
                text_ru: 'экологично безопасная утилизация',
                value: 8
            },
            {
                text_en: 'charity profit sharing',
                text_ro: 'partajarea profitului în scop caritabil',
                text_ru: 'распределение части прибыли на благотворительность',
                value: 9
            },
        ],
    },
    mutations: {
        loadAllProducts(state, payload) {
			state.products_all = payload
		},
        loadProducts(state, payload) {
			state.products = payload
		},
        loadTrademarks(state, payload) {
			state.trademarks = payload
		},
        addTeamProduct(state, payload) {
            let index = state.products?.length || 0;
			Vue.set(state.products, index, payload)   
        },
        addProduct(state, payload) {
            let index = state.products_all?.length || 0;
			Vue.set(state.products_all, index, payload)   
        },
        editTeamProduct(state, payload) {
            const prod = state.products?.find(s => s.id == payload.id)
            let index = state.products?.indexOf(prod);
            if (!prod) {
                state.products = payload;
            } else {
                Vue.set(state.products, index, {...prod, ...payload })  
            }   
        },
        editProduct(state, payload) {
            const prod = state.products_all?.find(s => s.id == payload.id)
            let index = state.products_all?.indexOf(prod);
            if (!prod) {
                state.products_all = payload;
            } else {
                Vue.set(state.products_all, index, {...prod, ...payload })  
            }   
        },
        deleteTeamProduct(state, payload) {
            state.products =  state.products?.filter(s => s.id !== payload)
        },
        deleteProduct(state, payload) {
            state.products_all =  state.products_all?.filter(s => s.id !== payload)
        }
    },
    actions: {
        //fetch all products by game id & round
        async fetchProducts({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //console.log(payload)
            try {
                const result = await http.get(`/product/game/${payload.gameId}?round=${payload.round}`);
                //console.log(result)
                if (result) {
                   const prods = result.data 
                   commit('loadAllProducts', prods) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async fetchTeamProducts({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const teamId = payload.teamId;
            const gameId = payload.gameId;
            const round = payload.round;
            
            try {
                const result = await http.get(`/product/team/${teamId}?gameId=${gameId}&round=${round}`);
                
                if (result && result.data) {
                   const prods = result.data 
                   commit('loadProducts', prods) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //trademarks
        async fetchTrademarks({ commit }) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.get(`/trademark`);
                //console.log(result)
                if (result) {
                   const trademarks = await result.data 
                   commit('loadTrademarks', trademarks)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addTeamProduct({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let team = {};
            const trademark = { name: payload.trademark };

            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            try {
                const result = await http.post(`/product`, payload);
                
                if (result) {
                    const prod = await result.data;
                    prod.team = team;
                    prod.trademark = trademark;
                    commit('addTeamProduct', prod)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addProduct({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let team = {};
            const trademark = { name: payload.trademark };

            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            try {
                const result = await http.post(`/product`, payload);
                
                if (result) {
                    const prod = await result.data;
                    prod.team = team;
                    prod.trademark = trademark;
                    commit('addProduct', prod)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async editTeamProduct({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            
            let team = {};
            let trademark = {};
            let model = '';

            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            if (payload.trademark) {
                trademark = payload.trademark;
                delete payload.trademark;
            }

            if (payload.model) {
                model = payload.model;
                delete payload.model;
            }

            try {
                await http.put(`/product/${payload.id}`, payload);

                payload.team = team;
                payload.trademark = trademark;
                payload.model = model;
                
                commit('editTeamProduct', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async editProduct({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            
            let team = {};
            let trademark = {};
            let model = '';

            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            if (payload.trademark) {
                trademark = payload.trademark;
                delete payload.trademark;
            }

            if (payload.model) {
                model = payload.model;
                delete payload.model;
            }

            try {
                await http.put(`/product/${payload.id}`, payload);

                payload.team = team;
                payload.trademark = trademark;
                payload.model = model;
                
                commit('editProduct', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteTeamProduct({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/product/${payload}`);
                commit('deleteTeamProduct', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteProduct({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/product/${payload}`);
                commit('deleteProduct', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async productsTransition({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //console.log(payload)
            try {
                await http.get(`/product/transition/${payload.gameId}?round=${payload.round}`);             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        products(state) {
            return state.products; //team products
        },
        products_all(state) {
            return state.products_all;
        },
        trademarks(state) {
            return state.trademarks;
        },
        DESIGN_TYPES(state) {
            return state.DESIGN_TYPES;
        },
        FEATURES (state) {
            return state.FEATURES;
        }
    }
}